import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { homeOperations } from './duck/index';
import {Link} from "react-router-dom";
import {dashboardOperations} from "../Dashboard/duck";
import Paper from "@mui/material/Paper";
class NewHome extends React.Component {

    componentDidMount() {
        this.props.getInfo();
    }

    render() {
        const userType = parseInt(localStorage.getItem('userType'));
        const { completedStudies, liveStudies } = this.props;
        return (
            <div className="home__main-box">
                <Paper elevation={0} style={{ padding:"32px 56px 40px", margin: "16px auto", textAlign: "center", borderRadius: 16}}>
        
                    <div className="home__text-container">
                        <h2>Welcome {this.props.homeReducer.first_name} to the Lumen Study Platform</h2>
                    </div>
                    <img className="home__img" src={this.props.homeReducer.company_url} alt=""/>
                    <div className="home__stats-container">
                        <div className="home__stats-font">Live Studies:</div>
                        <div className="home__stats-font">{ userType === 1 ? this.props.homeReducer.totalLive : liveStudies}</div>
                    </div>
                    <div className="home__stats-container">
                        <div className="home__stats-font">Total Completed:</div>
                        <div className="home__stats-font">{ userType === 1 ? this.props.homeReducer.totalCompleted : completedStudies}</div>
                    </div>
                    { userType === 1 ? <Link  to="/create-study" style={{textTransform: "uppercase", padding: "8px 20px" }} className="button-primary home__button">Create Study</Link> : ""}
            
                </Paper>
            </div>
        );
    }
}

function countNumberOfX(data, type) {
    const amount = data.filter(item => item[type] === true)
    return amount.length
}

NewHome.propTypes = {
    getInfo: PropTypes.func,
};

function mapStateToProps(state) {
    return {
        homeReducer: state.homeReducer,
        completedStudies: countNumberOfX(state.batchStimsReducer.batchData, 'completed'),
        liveStudies: countNumberOfX(state.batchStimsReducer.batchData, 'live')
    }
};

function mapDispatchToProps(dispatch) {
    return {
        getInfo: () => dispatch(homeOperations.getTotalInfo()),
        onAddNewStudy: () => dispatch(dashboardOperations.onAddNewStudy()),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(NewHome);
